import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { steddyTransition } from "@/lib/animations";

const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const steps = [
  {
    num: "01",
    title: "Submission",
    desc: "ISO or merchant submits application via portal or API.",
  },
  {
    num: "02",
    title: "AI Underwrite",
    desc: "Instant bank analysis, scoring, and risk decisioning.",
  },
  {
    num: "03",
    title: "Auto Login",
    desc: "No more waiting around for hours to chase down a login.",
  },
  {
    num: "04",
    title: "Servicing",
    desc: "ACH collection, renewal detection, and default management.",
  },
];

const LoopSection = () => (
  <section id="platform" className="bg-background py-32">
    <div className="container mx-auto px-6">
      <motion.div {...fadeInUp} transition={steddyTransition} className="mb-16 text-center">
        <span className="text-xs font-semibold uppercase tracking-wider text-primary">
          Our Process
        </span>
        <h2 className="mt-4 text-3xl font-bold text-foreground md:text-4xl">
          Why Steddy.AI,
          <br />
          Why now?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">
          Steddy.AI eliminates the traditional obstacles of scaling an MCA platform with faster
          approvals, smarter funding, and zero manual overhead.
        </p>
      </motion.div>

      <div className="mx-auto grid max-w-5xl gap-4 md:grid-cols-4">
        {steps.map((step, i) => (
          <motion.div
            key={step.num}
            {...fadeInUp}
            transition={{ ...steddyTransition, delay: i * 0.1 }}
            className="card-surface-light card-hover-light relative rounded-2xl bg-background p-6"
          >
            <span className="text-xs font-bold text-primary">{step.num}</span>
            <h3 className="mt-3 text-lg font-semibold text-foreground">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{step.desc}</p>
            {i < steps.length - 1 && (
              <ArrowRight className="absolute -right-3 top-1/2 z-10 hidden h-5 w-5 -translate-y-1/2 text-primary/40 md:block" />
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default LoopSection;
